// TermsPrivacyLinks.tsx
import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const TermsPrivacyLinks = ({
  align = "center",
  fontSize = "12px",
  color = "#9B9B9B",
}) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isMediumScreen ? "center" : "start",
        gap: 3,
        mt: 2,
      }}
    >
      <Typography
        component="a"
        href={`${process.env.REACT_APP_BASE_URL}/Files/Terms-of-Use`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color,
          fontSize,
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        Terms of Use
      </Typography>

      <Typography
        component="a"
        href={`${process.env.REACT_APP_BASE_URL}/Files/Privacy-Policy`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color,
          fontSize,
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        Privacy Policy
      </Typography>
    </Box>
  );
};

export default TermsPrivacyLinks;
